import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BibliothequePilotageDetailModel } from 'src/models/pilotage/bibliothequePilotageDetailModel';
import { BibliothequePilotageModel } from 'src/models/pilotage/bibliothequePilotageModel';
import { CreerBibliothequeModel } from 'src/models/pilotage/creerBibliothequeModel';
import { ModifierBibliothequeModel } from 'src/models/pilotage/modifierBibliothequeModel';
import { AuthService } from './auth.service';
import { UtilisateurService } from './utilisateur.service';
import { ContexteBibliothequeModel } from 'src/models/pilotage/contexteBibliothequeModel';

@Injectable({
  providedIn: 'root'
})
export class BibliothequesService {
  private baseUrl = environment.api_LMS + 'Bibliotheque';

  constructor(private http: HttpClient,
    private translateService: TranslateService,
    private authService: AuthService,
    private utilisateurService: UtilisateurService) { }

  obtenirBibliotheques(): Observable<BibliothequePilotageModel[]> {
    return this.http.get<BibliothequePilotageModel[]>(`${this.baseUrl}/ObtenirBibliotheques`);
  }

  obtenirBibliotheque(bibliothequeId: number): Observable<BibliothequePilotageDetailModel> {
    return this.http.get<BibliothequePilotageDetailModel>(`${this.baseUrl}/ObtenirBibliotheque`, {
      params: { bibliothequeId }
    });
  }

  obtenirContexteBibliotheque(): Observable<ContexteBibliothequeModel> {
    return this.http.get<ContexteBibliothequeModel>(`${this.baseUrl}/ObtenirContexteBibliotheque`);
  }

  creerBibliotheque(model: CreerBibliothequeModel): Observable<void> {
    model.creePar = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    return this.http.post<void>(`${this.baseUrl}/CreerBibliotheque`, model);
  }

  modifierBibliotheque(model: ModifierBibliothequeModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/ModifierBibliotheque`, model);
  }

  supprimerBibliotheque(bibliothequeId: number): Observable<void> {
    const retirePar = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    return this.http.put<void>(`${this.baseUrl}/SupprimerBibliotheque`, null, {
      params: { bibliothequeId, retirePar }
    });
  }

  getNomLocalise(locales: { [key: string]: string }): string {
    const currentLang = this.translateService.currentLang || 'fr';

    if (locales[currentLang] && locales[currentLang].trim()) {
      return locales[currentLang];
    }

    const fallbackOrder = ['fr', 'en', 'es'];

    for (const lang of fallbackOrder) {
      if (locales[lang] && locales[lang].trim()) {
        return locales[lang];
      }
    }

    return '';
  }
}
